// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2hmE7","Success":"Button_Success__19lb9","Danger":"Button_Danger__C-6vG"};